export default __webpack_public_path__ + "static/media/coke.6408f1b7.png";